import { useEffect } from "react";
import { Header } from "../components/header";
import { trackPageView } from "../utils/segment";

export function ChefChallengeWinners() {
  useEffect(() => {
    trackPageView("Landed on the Chef Challenge Winners Page");
  }, []);

  // Mock data for winners - replace with actual data from your backend
  const winners = [
    {
      position: 1,
      name: "Chef Roland",
      instagramHandle: "@deerolls.kitchen_shawarma",
      prize: "₦300,000",
      votes: 1301,
      postLink: "https://instagram.com/p/ABC123xyz",
    },
    {
      position: 2,
      name: "Chef Naaya",
      instagramHandle: "@chef_chinedu",
      recipe: "Mangrove Sweet Corn Pancakes",
      prize: "₦200,000",
      votes: 1084,
      postLink: "https://instagram.com/p/DEF456uvw",
    },
    {
      position: 3,
      name: "Chef Sauce",
      instagramHandle: "@dungs_of_lagos",
      prize: "₦100,000",
      votes: 234,
      postLink: "https://instagram.com/p/GHI789rst",
    },
  ];

  const getPositionIcon = (position) => {
    switch (position) {
      case 1:
        return "🥇";
      case 2:
        return "🥈";
      case 3:
        return "🥉";
      default:
        return "🏆";
    }
  };

  const getPositionClass = (position) => {
    switch (position) {
      case 1:
        return "first-place";
      case 2:
        return "second-place";
      case 3:
        return "third-place";
      default:
        return "";
    }
  };

  const getAvatarInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();
  };

  const getAvatarClass = (position) => {
    switch (position) {
      case 1:
        return "first-place-avatar";
      case 2:
        return "second-place-avatar";
      case 3:
        return "third-place-avatar";
      default:
        return "";
    }
  };

  return (
    <div className='challenge-winners-page'>
      <Header />
      {/* Hero Section */}
      <div className='winners-hero-section'>
        <div className='container'>
          <div className='hero-content'>
            <div className='hero-badge'>
              <i className='fas fa-trophy'></i>
              <span>Winners Announced</span>
            </div>
            <h1 className='hero-title'>
              Mangrove <span className='gradient-text'>Chef Challenge</span>{" "}
              Winners
            </h1>
            <p className='hero-description'>
              Congratulations to our amazing winners! These talented chefs
              showcased incredible creativity and skill using Mangrove Foods
              products.
            </p>
            <div className='announcement-date'>
              <i className='fas fa-calendar'></i>
              <span>Winners announced on October 30, 2025</span>
            </div>
          </div>
        </div>
      </div>
      {/* Winners Section */}
      <div className='winners-section'>
        <div className='container'>
          <div className='section-header'>
            <h2>Our Amazing Winners</h2>
            <p>
              Meet the talented chefs who impressed our judges and won the
              hearts of our audience
            </p>
          </div>

          <div className='winners-container'>
            {winners.map((winner, index) => (
              <div
                key={winner.position}
                className={`winner-card ${getPositionClass(winner.position)}`}
              >
                {/* Card Header with Position & Prize */}
                <div className='card-header'>
                  <div className='position-indicator'>
                    <div className='position-number'>{winner.position}</div>
                    <div className='position-medal'>
                      {getPositionIcon(winner.position)}
                    </div>
                  </div>
                  <div className='prize-display'>
                    <span className='prize-amount'>{winner.prize}</span>
                    <span className='prize-label'>Prize</span>
                  </div>
                </div>

                {/* Winner Profile Section */}
                <div className='winner-profile-section'>
                  <div className='avatar-container'>
                    <div
                      className={`winner-avatar ${getAvatarClass(
                        winner.position
                      )}`}
                    >
                      <span className='avatar-initials'>
                        {getAvatarInitials(winner.name)}
                      </span>
                    </div>
                    <div className='avatar-ring'></div>
                  </div>

                  <div className='winner-details'>
                    <h3 className='winner-name'>{winner.name}</h3>
                    <div className='winner-location'>
                      <i className='fas fa-map-marker-alt'></i>
                      <span>{winner.location}</span>
                    </div>
                    <a
                      href={`https://instagram.com/${winner.instagramHandle.replace(
                        "@",
                        ""
                      )}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='instagram-link'
                    >
                      <i className='fab fa-instagram'></i>
                      <span>{winner.instagramHandle}</span>
                    </a>
                  </div>
                </div>

                {/* Stats Grid */}
                <div className='stats-grid'>
                  <div className='stat-item'>
                    <div className='stat-icon'>
                      <i className='fas fa-vote-yea'></i>
                    </div>
                    <div className='stat-value'>
                      {winner.votes.toLocaleString()}
                    </div>
                    <div className='stat-label'>Votes</div>
                  </div>
                </div>

                {/* Action Button */}
                <div className='card-actions'>
                  <a
                    href={winner.postLink}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='view-post-btn'
                  >
                    <i className='fas fa-external-link-alt'></i>
                    <span>View Winning Post</span>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Statistics Section */}
      <div className='stats-section'>
        <div className='container'>
          <div className='section-header'>
            <h2>Challenge Statistics</h2>
            <p>Amazing numbers from our first Mangrove Chef Challenge</p>
          </div>

          <div className='stats-grid'>
            <div className='stat-card'>
              <div className='stat-icon'>
                <i className='fas fa-video'></i>
              </div>
              <div className='stat-number'>247</div>
              <div className='stat-label'>Total Entries</div>
            </div>

            <div className='stat-card'>
              <div className='stat-icon'>
                <i className='fas fa-users'></i>
              </div>
              <div className='stat-number'>189</div>
              <div className='stat-label'>Participants</div>
            </div>

            <div className='stat-card'>
              <div className='stat-icon'>
                <i className='fas fa-heart'></i>
              </div>
              <div className='stat-number'>15.2K</div>
              <div className='stat-label'>Total Likes</div>
            </div>

            <div className='stat-card'>
              <div className='stat-icon'>
                <i className='fas fa-share'></i>
              </div>
              <div className='stat-number'>3.8K</div>
              <div className='stat-label'>Total Shares</div>
            </div>

            <div className='stat-card'>
              <div className='stat-icon'>
                <i className='fas fa-eye'></i>
              </div>
              <div className='stat-number'>45.6K</div>
              <div className='stat-label'>Total Views</div>
            </div>

            <div className='stat-card'>
              <div className='stat-icon'>
                <i className='fas fa-trophy'></i>
              </div>
              <div className='stat-number'>₦600K</div>
              <div className='stat-label'>Total Prizes</div>
            </div>
          </div>
        </div>
      </div>
      {/* Thank You Section */}
      <div className='thank-you-section'>
        <div className='container'>
          <div className='thank-you-content'>
            <h2>Thank You to All Participants!</h2>
            <p>
              We were blown away by the creativity, passion, and culinary skills
              displayed by all participants. Each entry brought something unique
              to the table, making the judging process incredibly difficult.
            </p>
            <p>
              Stay tuned for more exciting challenges and opportunities to
              showcase your talent with Mangrove Foods!
            </p>

            <div className='cta-buttons'>
              {/* <a href='/chef-challenge' className='cta-button primary'>
                <i className='fas fa-utensils'></i>
                View Challenge Details
              </a> */}
              <a href='/products' className='cta-button secondary'>
                <i className='fas fa-shopping-bag'></i>
                Shop Mangrove Products
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
